import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';

// Import components
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Register from './components/Register';
import ChangePassword from './components/ChangePassword';
import FoodPrediction from './components/FoodPrediction';
import CostCalculation from './components/CostCalculation';
import Inventory from './components/Inventory';
import DashboardHome from './components/DashboardHome';
import Homepage from './components/Homepage';
import Notifications from './components/Notifications';
import Analytics from './components/Analytics';
import Settings from './components/Settings';
import Reports from './components/Reports';

// Auth context
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <AuthProvider>
      <Box className="gradient-bg" sx={{ minHeight: '100vh' }}>
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route 
              path="/login" 
              element={
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.3 }}
                >
                  <Login />
                </motion.div>
              } 
            />
            <Route 
              path="/register" 
              element={
                <motion.div
                  initial={{ opacity: 0, x: -50 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 50 }}
                  transition={{ duration: 0.3 }}
                >
                  <Register />
                </motion.div>
              } 
            />
            <Route 
              path="/change-password" 
              element={
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <ChangePassword />
                </motion.div>
              } 
            />
            <Route path="/dashboard" element={<Dashboard />}>
              <Route index element={<Navigate to="/dashboard/home" replace />} />
              <Route path="home" element={<DashboardHome />} />
              <Route path="food-prediction" element={<FoodPrediction />} />
              <Route path="cost-calculation" element={<CostCalculation />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="notifications" element={<Notifications />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="reports" element={<Reports />} />
            </Route>
          </Routes>
        </AnimatePresence>
      </Box>
    </AuthProvider>
  );
}

export default App;